// $("#increaseText").click(function() {
//     $(".text").toggleClass("increased");
//     $(".content").toggleClass("increased");
//     $("body").toggleClass("textIncreased");
// });



// Funzione per impostare un cookie con nome, valore e giorni di scadenza
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

// Funzione per ottenere il valore di un cookie
function getCookie(name) {
    const cookieArr = document.cookie.split("; ");
    for (let cookie of cookieArr) {
        const [key, val] = cookie.split("=");
        if (key === name) return val;
    }
    return null;
}

// Funzione per attivare/disattivare le classi e gestire il cookie
function toggleTextSize() {
    // Aggiunge o rimuove le classi
    $(".text").toggleClass("increased");
    $(".content").toggleClass("increased");
    $(".searchContent").toggleClass("increased");
    $("body").toggleClass("textIncreased");

    // Controlla lo stato attuale della classe e imposta/rimuove il cookie
    if ($("body").hasClass("textIncreased")) {
        setCookie("textSize", "increased", 7); // Imposta il cookie con scadenza 7 giorni
    } else {
        setCookie("textSize", "", -1); // Rimuove il cookie
    }
}

// Al caricamento della pagina, verifica se il cookie è settato
$(document).ready(function() {
    if (getCookie("textSize") === "increased") {
        $(".text").addClass("increased");
        $(".content").addClass("increased");
        $(".searchContent").addClass("increased");
        $("body").addClass("textIncreased");
    }
});

// Assegna l'evento click al pulsante
$("#increaseText").click(toggleTextSize);
